<h1>Contact types</h1>
<acabim-datatable
    #dataTable
    [dataSources]="dataSources"
    (outDataSource)="getCurrent($event)"
    [hasDetailView]="true">
</acabim-datatable>

<p-footer class="cas-action-buttons">
    <button type='button' class="cas-button-action _t-add-contact-type" (click)="onAddContactType()">Add contact type</button>
</p-footer>

<acabim-modal
        [display]="addContactTypeModal"
        [title]="'Add contact type details'"
        (status)="setAddContactTypeModal($event)"
        [footer]="false"
        width="80vw"
        fixHeight="80vh">
    <acabim-admin-contact-type-add
        *ngIf="addContactTypeModal"
        actionType="add"
        actionButtonLabel="Add"
        (completed)="onAddCompletion($event)">
    </acabim-admin-contact-type-add>
</acabim-modal>

<ng-template [ngIf]="dataSources[currentDataSource].showDetails">
    <acabim-modal
            [display]="true"
            [title]="'Edit contact type details'"
            (status)="setEditContactTypeModal($event)"
            [footer]="false"
            fixHeight="80vh"
            width="80vw">
        <acabim-admin-contact-type-update
                [contactTypeDetails]="dataSources[currentDataSource].detailData"
                (completed)="onEditCompletion($event)">
        </acabim-admin-contact-type-update>
    </acabim-modal>
</ng-template>
